import { BgImage } from 'gbimage-bridge';
import styled from '@emotion/styled';

const BackgroundImage100 = styled(BgImage)`
  width: 100%;
  height: 100%;
`;

export default BackgroundImage100;
